export const createAutomaticKeyframes = (layerStartTime, layerEndTime, currentBox, domElement) => {
  const n = layerStartTime;
  const r = layerEndTime;
  const epsilon = 0.00001;

  // Get current position and size from the box, checking multiple possible locations
  let currentPositionX = "0%";
  let currentPositionY = "0%";
  let currentWidth = "25%";

  if (currentBox) {
    // Check different possible locations for position data
    currentPositionX =
      currentBox?.style?.left ||
      currentBox?.left ||
      currentBox?.position?.x ||
      currentBox?.x ||
      "0%";

    currentPositionY =
      currentBox?.style?.top || currentBox?.top || currentBox?.position?.y || currentBox?.y || "0%";

    currentWidth =
      currentBox?.style?.width ||
      currentBox?.width ||
      currentBox?.size?.width ||
      currentBox?.structure?.width ||
      "25%";

    // Try to get width from DOM element if available
    if (domElement && domElement.style.width) {
      currentWidth = domElement.style.width;
    } else if (domElement) {
      // Get computed width as percentage if available
      const computedStyle = window.getComputedStyle(domElement);
      const parentWidth = domElement.parentElement?.offsetWidth;
      const elementWidth = domElement.offsetWidth;
      if (parentWidth && elementWidth) {
        currentWidth = ((elementWidth / parentWidth) * 100).toFixed(2) + "%";
      }
    }
  }

  const keyframes = [
    {
      positionx: currentPositionX,
      positiony: currentPositionY,
      opacity: 0,
      width: currentWidth,
      duration: 0,
    },
    {
      positionx: currentPositionX,
      positiony: currentPositionY,
      opacity: 0,
      width: currentWidth,
      duration: n,
    },
    {
      positionx: currentPositionX,
      positiony: currentPositionY,
      opacity: 1,
      width: currentWidth,
      duration: n + epsilon,
    },
    {
      positionx: currentPositionX,
      positiony: currentPositionY,
      opacity: 1,
      width: currentWidth,
      duration: r,
    },
    {
      positionx: currentPositionX,
      positiony: currentPositionY,
      opacity: 0,
      width: currentWidth,
      duration: r + epsilon,
    },
  ];

  return keyframes;
};

export const shouldCreateAutomaticKeyframes = (oldStructure, newStructure, existingKeyframes) => {
  const oldWidth = oldStructure?.width;
  const newWidth = newStructure?.width;

  const widthChanged = oldWidth !== newWidth && newWidth !== undefined;
  const hasNoExistingKeyframes = !existingKeyframes || existingKeyframes.length === 0;

  return widthChanged && hasNoExistingKeyframes;
};

export const shouldCreateAutomaticKeyframesForLayerResize = (
  oldLayer,
  newLayer,
  existingKeyframes
) => {
  if (!oldLayer || !newLayer) return false;

  const oldDuration = oldLayer.endFrame - oldLayer.startFrame;
  const newDuration = newLayer.endFrame - newLayer.startFrame;
  const layerWidthChanged = oldDuration !== newDuration;
  const hasNoExistingKeyframes = !existingKeyframes || existingKeyframes.length === 0;

  return layerWidthChanged && hasNoExistingKeyframes;
};

export const shouldCreateAutomaticKeyframesForLayerMove = (
  oldLayer,
  newLayer,
  existingKeyframes
) => {
  if (!oldLayer || !newLayer) return false;

  const layerPositionChanged =
    oldLayer.startFrame !== newLayer.startFrame || oldLayer.endFrame !== newLayer.endFrame;
  const hasNoExistingKeyframes = !existingKeyframes || existingKeyframes.length === 0;

  // Check if existing keyframes are automatic (5 keyframes with specific pattern)
  const hasAutomaticKeyframes =
    existingKeyframes &&
    existingKeyframes.length === 5 &&
    existingKeyframes[0].opacity === 0 &&
    existingKeyframes[1].opacity === 0 &&
    existingKeyframes[2].opacity === 1 &&
    existingKeyframes[3].opacity === 1 &&
    existingKeyframes[4].opacity === 0;

  return layerPositionChanged && (hasNoExistingKeyframes || hasAutomaticKeyframes);
};
